import { initialValuesArea as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/areaType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const areaReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_AREA:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_AREA:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_AREA:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_AREA:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_AREA:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_AREA:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_AREA:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_AREA:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_AREA:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_AREA:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_AREA:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_AREA:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default areaReducer;
